module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "clearfix copyright",
    staticStyle: {
      "line-height": "25px"
    }
  }, [_c('div', {
    staticClass: "l",
    staticStyle: {
      "margin-right": "40px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "opacity": "1"
    },
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.togs()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "display": "inline-block",
      "margin-top": "-2px",
      "margin-right": "5px",
      "width": "18px",
      "height": "18px",
      "vertical-align": "middle"
    },
    attrs: {
      "src": require("../assets/images/gs.png")
    }
  }), _vm._v("浙江工商网络监管\n          ")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "opacity": "1",
      "padding-left": "10px"
    },
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.toga()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "display": "inline-block",
      "margin-top": "-2px",
      "margin-right": "5px",
      "width": "18px",
      "height": "18px",
      "vertical-align": "middle"
    },
    attrs: {
      "src": require("../assets/images/gonganbeian.png")
    }
  }), _vm._v("\n            浙公网安备 33010802007761号")])])]), _vm._v(" "), _c('div', {
    staticClass: "l"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "webmap clearfix"
  }, [_c('dl', [_c('dt', [_c('img', {
    staticStyle: {
      "width": "123px"
    },
    attrs: {
      "src": require("../assets/images/logo_bak.png")
    }
  })]), _vm._v(" "), _c('dd', [_vm._v("趣编网是一个集短视频创作、交易、推广运营于一体的平台，服务于视频需求方和视频创作者，致力于打造视频梦工厂。")])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("关于我们")]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "flow.html"
    }
  }, [_vm._v("服务流程")])]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "question.html"
    }
  }, [_vm._v("常见问题")])]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "about.html"
    }
  }, [_vm._v("公司介绍")])])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v(" ")]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "agreement.html"
    }
  }, [_vm._v("趣编网服务协议")])]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "policy.html"
    }
  }, [_vm._v("趣编网隐私政策")])])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("联系我们")]), _vm._v(" "), _c('dd', [_vm._v("咨询热线  0571-86885271")]), _vm._v(" "), _c('dd', [_vm._v("工作时间  9:00-18:00  (周一至周五)")]), _vm._v(" "), _c('dd', [_c('a', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "id": "qvQ2"
    }
  }, [_c('i', {
    staticClass: "qq"
  }), _vm._v("客服QQ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://weibo.com/u/6066981669?is_hot=1",
      "target": "_blank",
      "rel": "nofollow"
    }
  }, [_c('i', {
    staticClass: "blog"
  }), _vm._v("新浪微博")])])]), _vm._v(" "), _c('dl', [_c('dd', [_c('img', {
    attrs: {
      "src": require("../assets/images/qr.png"),
      "width": "100",
      "height": "100",
      "alt": "趣编官方公众号"
    }
  })]), _vm._v(" "), _c('dd', [_vm._v("扫一扫关注官方微信")])]), _vm._v(" "), _c('dl', [_c('dd', [_c('img', {
    attrs: {
      "src": require("../assets/images/qr2.jpg"),
      "width": "100",
      "height": "100",
      "alt": "趣编官方公众号"
    }
  })]), _vm._v(" "), _c('dd', [_vm._v("扫一扫关注小程序")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Copyright © 2017 趣编网 All Rights Reserved "), _c('a', {
    attrs: {
      "href": "http://beian.miit.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("浙ICP备17002490号-1")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f60d9296","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 26
// module chunks = 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44